/* eslint-disable no-var */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';
import { environment } from 'src/environments/environment';
import { Readable } from 'stream';
import { DomSanitizer } from '@angular/platform-browser';
import {  observable, Observable, of } from 'rxjs';
import { BooleanValueAccessorDirective } from '@ionic/angular/directives/control-value-accessors/boolean-value-accessor';

@Injectable({
  providedIn: 'root'
})
export class WasabiService {

   S3 = require('aws-sdk/clients/s3');
   bucket = new S3(
  {
  accessKeyId: environment.WSaccessKeyId,
  secretAccessKey: environment.WSsecretAccessKey,
  region: environment.WSregion,
  endpoint: environment.WSendpoint
  });

  fileURL;

  constructor(private sanitizer: DomSanitizer) { }

   public fileUpload(file, folder, fileName) {
    const contentType = file.type;
    const params = {
    Bucket: environment.WSBucket,
    Key: folder+'/'+fileName,
    Body: file,
    ACL: 'private',
    ContentDisposition: 'attachment; filename='+ fileName,
    ContentType: contentType
    };
    this.bucket.upload(params, function(err, data) {
    if (err) {
    console.log('ERROR: ',JSON.stringify( err));
    return false;
    }
    console.log('File Uploaded.');
    return true;
    });
  }

   public downloadFile(folder, fileName) {
    var objectData;
    const params = {
      Bucket: environment.WSBucket,
      Key: folder+'/'+fileName
    };
     var od = this.bucket.getObject(params, function(err, data) {
      if (err) {
      console.log('ERROR: ',JSON.stringify( err));
      return false;
      }
      var binaryData = [];
      binaryData.push(data.Body);

      objectData = new Blob(binaryData, { type: data.ContentType });
      //console.log(objectData);
      return objectData;

      });
      }

  public getFile(folder, fileName) {
    const params = {
    Bucket: environment.WSBucket,
    Key: folder+'/'+fileName
    };
    return this.bucket.getObject(params);
  }

  public deleteFile(folder, fileName) {
    const params = {
    Bucket: environment.WSBucket,
    Key: folder+'/'+fileName
    };
    this.bucket.deleteObject(params, function(err, data) {
    if (err) {
    console.log('ERROR: ',JSON.stringify( err));
    return false;
    }
    //return ;
    console.log('File Deleted');
    return true;
    });
  }

  public deleteFolder(folder) {
    const params = {
      Bucket: environment.WSBucket,
      Key: folder
      };
      this.bucket.deleteObject(params, function(err, data) {
      if (err) {
      console.log('ERROR: ',JSON.stringify( err));
      return false;
      }
      //return ;
      console.log('File Deleted');
      return true;
      });
  }

  public listFolderContent(folder){
    var list = [];
    var params = {
      Bucket: environment.WSBucket,
      Prefix: folder
      };
      this.bucket.listObjects(params, function(err, data) {
        data.Contents.forEach(function(content) {
          console.log(content);
          list.push(content);
        });
       /* this.bucket.deleteObjects(params, function(err1, data1) {
            console.log(data1);
        }); */
      if (err) {
      console.log('ERROR: ',JSON.stringify( err));
      return false;
      }
      //return ;
      console.log('content found');
      return list;
      });
  }
}


